import Icon from '../components/Icon.vue'

Icon.register({
  'fast-backward': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M0 436v-360c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v151.9l171.5-156.5c20.6-17.1 52.5-2.8 52.5 24.6v131.9l171.5-156.5c20.6-17.1 52.5-2.8 52.5 24.6v320c0 27.4-31.9 41.7-52.5 24.6l-171.5-155.3v130.7c0 27.4-31.9 41.7-52.5 24.6l-171.5-155.3v150.7c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/fast-backward.js
// module id = 1320
// module chunks = 0